import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('Select');
const componentType = 'select';

const propTypes = {
    emptyLabel: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    selectRef: PropTypes.func,
    selected: PropTypes.string,
    type: PropTypes.string,
    hasError: PropTypes.bool,
};
Select.componentType = componentType;

function Select(props) {
    const { emptyLabel, className, children, selectRef, selected, type, hasError, ...rest } = props;
    // we have placeholder text and nothing has been selected yet, we are on the placeholder text.
    const placeholderText = emptyLabel && !selected ? 'placeholderText' : 'selectableOption';
    const errorClass = hasError ? 'selectWithError' : undefined;

    return (
        <div className={bem(null, errorClass, className)}>
            <select className={bem('field', [type, placeholderText])} {...rest} ref={selectRef}>
                {emptyLabel && (
                    <option value="" disabled>
                        {emptyLabel}
                    </option>
                )}
                {children}
            </select>
        </div>
    );
}

Select.propTypes = propTypes;

export default Select;
